module.exports = __webpack_public_path__ + "img/download-tp-uat-backup.5802d222.png";